import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as engagement from '../engagement'

// TODO: We may want to make this an enum in the future if we want to have a fixed set of roles that can be filled for an engagement. For now, we'll leave it as a text field to allow for more flexibility.
export const RESOURCE = {
  payload: {
    canBeOptional: true,
    constraints: {
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagement.RESOURCE.payload.dimension.partialId,
      partialId: engagement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Base role type filled by this employee for this project on this engagement.',
    isOptional: true,
    name: 'Role',
    partialId: PartialId.Standard.create('role'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
